import React, { Fragment } from 'react'
import { Route } from 'react-router-dom';
import { EODDetailsReportListing } from './Pages'

export const EODDetailsReportRoutes = ({ match }) => (
    <Fragment>
        <Route exact path={`${match.path}`} component={EODDetailsReportListing} />
    </Fragment>
)